import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid, Button } from "@mui/material";
// import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";

import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import AddEditSOS from "./AddNewSOS";
// import AddNewSOS from "./AddNewSOS";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import Pagination from "@mui/material/Pagination";
// End

function ManageSOS() {
  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {


    setOpen(true);
    setScroll(scrollType);

  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  // React.useEffect(() => {
  //   if (open) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [open]);
  // End

  // For Modal
  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");
  const [SOSList, setSOSList] = React.useState([]);

  const handleClickOpen2 = (scrollType, sosId) => () => {
    getSOSById(sosId);
    setOpen2(true);
    setScroll2(scrollType);
  };


  const handleClose2 = () => {
    setOpen2(false);
  };

  const descriptionElementRef2 = React.useRef(null);

  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  // const [isSOSAvailable, setIsSOSAvailable] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [q, setQ] = React.useState("");
  const [Upload] = React.useState(false);
  const [sortBy, setSortBy] = React.useState("");
  const [selected, setSelected] = React.useState(false);
  const [, setAnchorEl] = React.useState(null);
  const [sosId, setsosId] = React.useState("");

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);


  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  async function handleChangeSortBy(event, residentType) {
    if (sortBy === "ASC") {
      setSortBy("DESC");
    } else {
      setSortBy("ASC");
    }
    await getAllSOS();

    setAnchorEl(event.currentTarget);
  }

  // delete SOS
  async function deleteSOS(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      setShowLoader(true);
      var bodyFormData = new FormData();
      makeGetRequest("commonapis/deletesos/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            getAllSOS();
          } else {
            swal("Error", "Failed to delete", "error");
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
          console.log("Invalid username password!!", err);
        });
    }
  }

  async function getSOSById(sosId) {

    setShowLoader(true);

    await makeGetRequest("commonapis/getsosbyid/" + sosId)
      .then(async (response) => {
        console.log(response.data.data);
        // setTitle(response.data.data.)
        // handleClickOpen("body")
        setTitle(response.data.data.sos_name);
        setDescription(response.data.data.sos_description);
        setsosId(response.data.data.sos_id)
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
      });
  }

  async function addSOS() {

    setShowLoader(true);
    if (title != "" && description != "") {
      let isSOSAvailable = false;
      let inputData = {
        sosName: title
      }
      await makePostRequest("commonapis/getsosbyname", inputData)
        .then(async (response) => {
          console.log(response.data.data.length);
          if (response.data.data.length == 0) {
            isSOSAvailable = false;
          }
          else
            isSOSAvailable = true;
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
        });

      if (!isSOSAvailable) {
        var inputData2 = {
          "sos_name": title.trim(),
          "sos_description": description
        }
        setShowLoader(true);
        await makePostRequest("commonapis/createSos", inputData2)
          .then(async (response) => {
            console.log(response);
            if (response.data.data !== undefined) {
              console.log(response);
              swal("Success", "SOS Created Successfully.", "success", {
                timer: 2000,
                buttons: false,
              });

              getAllSOS();
              handleClose();

            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal(
              "Incorrect Code !!",
              "Verification code doesen't match",
              "warning"
            );
          });
      }
      else {
        swal(
          "SOS Already Created!!",
          "SOS with given name already exist",
          "warning", {
          timer: 3000,
          buttons: false
        }
        );
      }

    }
    else
      swal(
        "Invalid Data !!",
        "Please Add SOS Title and Description",
        "warning"
      );

  }

  async function editSOS() {
    setShowLoader(true);

    if (title !== "" && description !== "") {
      let isSOSAvailable = false;

      await makePostRequest("commonapis/getsosbyname", { sosName: title })
        .then((response) => {
          const existingSOS = response.data.data;

          if (existingSOS.length === 0 || (existingSOS.length === 1 && existingSOS[0].sos_id === sosId)) {

            isSOSAvailable = false;
            setShowLoader(false);
          } else {

            isSOSAvailable = true;
            swal("SOS Already Created!!", "SOS with given name already exists", "warning", {
              timer: 3000,
              buttons: false
            });
            setShowLoader(false);
          }
        })
        .catch((error) => {
          setShowLoader(false);
          swal("Error", "Failed to check SOS.", "error");
        });

      if (!isSOSAvailable) {

        const updateData = {
          sos_id: sosId,
          sos_name: title.trim(),
          sos_description: description
        };

        setShowLoader(true);

        await makePostRequest("commonapis/updateSos", updateData)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "SOS Updated Successfully.", "success", {
                timer: 2000,
                buttons: false,
              });

              getAllSOS();
              handleClose2();
            }
          })
          .catch((error) => {
            setShowLoader(false);
            swal("Error", "Failed to update SOS.", "error");
          })
          .finally(() => {
            setShowLoader(false);
          });
      }
    } else {
      swal("Invalid Data !!", "Please Add SOS Title and Description", "warning");
      setShowLoader(false);
    }
  }


  async function getAllSOS() {
    let bodyFormData = {
      searchString: q,
      pageNo: currentPage,
      count: itemsPerPage,
      sort: sortBy
    }
    setShowLoader(true);
    await makePostRequest("commonapis/getAllSosList/", bodyFormData)
      .then((response) => {
        console.log(response);
        if (response.data.status === "1") {
          console.log(response.data.data);

          setSOSList(response.data.data.data);
          setTotalItems(response.data.data.total_records);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", err, "warning");
      });
  }


  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef2;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    getAllSOS();
  }, [open, open2, q, Upload,currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);
  // async function getAllSOS() {
  //   await makeGetRequest("commonapis/getAllSos/")
  //     .then((response) => {
  //       console.log(response);
  //       if (response.data.status === "1") {
  //         console.log(response.data.data);

  //         setSOSList(response.data.data);
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", err, "warning");
  //     });
  // }


  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Manage SOS</h1>
            <Button
              className="contentTopLefBt"
              onClick={handleClickOpen("body")}
            >
              Add New SOS
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">All SOS</div>
                <div className="visitorListNewInner">
                  <div className="visitorSearch">
                    <div className="visitorSearchDiv">
                      <SearchIcon className="visitorSearchIco" />
                      <input type="text" placeholder="Search" onChangeCapture={(e) => setQ(e.target.value)} />
                      {/* <MicIcon className="visitorMicIco" /> */}
                    </div>
                    <div className="sortingIcoOut">
                      <ToggleButton
                        value="check"
                        selected={selected}
                        onChange={() => {
                          setSelected(!selected);
                        }}
                      >
                        <ImportExportIcon
                          className="visitorFilterIco"
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={(e) => handleChangeSortBy(e, 'Tenent')}
                        />
                      </ToggleButton>
                    </div>


                  </div>

                  {SOSList.map((option) => (
                    <div className="visitContDiv sosContMain">
                      <div className="visitCont1 resideNewContOut">
                        <div className="visitContLeft visitContLeft2">
                          <h5 className="sosHeadingTx">{option.sos_name}</h5>
                          <p className="visitContTime">{option.sos_description}</p>
                        </div>
                        {/* <Button className="dashSOSB sendDashSOSB">
                          Send SOS
                        </Button> */}
                        <div className="resideNewCont">
                          <CreateIcon
                            className="editBt"
                            onClick={handleClickOpen2("body", option.sos_id)}
                          />
                          <DeleteIcon className="deleteBt" onClick={() => deleteSOS(option.sos_id)} />
                        </div>
                      </div>
                    </div>
                  ))}
                  <Grid container spacing={3} >
                    <Grid item xs={12} md={12} >
                      <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Add New SOS */}
      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add New SOS</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <AddAlertIcon />
                      <input className="modalInputSt" placeholder="Title of SOS" onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <textarea
                      className="textAriaSt"
                      placeholder="Enter message here"
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={() => addSOS()}>
                        Create SOS
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>
                        SOS Created <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Edit SOS */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit SOS</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <AddAlertIcon />
                      <input className="modalInputSt" placeholder="Title of SOS" onChange={(e) => setTitle(e.target.value)} value={title}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <textarea
                      className="textAriaSt"
                      placeholder="Enter message here"
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                    ></textarea>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={() => editSOS()}>
                        Update SOS
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>
                        SOS Created <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

    </>
  );
}

export default ManageSOS;
